import { createContext, useContext, useState, useEffect } from "react";
import { BASE_URL } from "../../env";

const AdminAuthContext = createContext();

const AdminAuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(() => {
    const storedAdminUser = localStorage.getItem("adminUser");
    return storedAdminUser ? JSON.parse(storedAdminUser) : null;
  });
  const [accessTypes, setAccessTypes] = useState(() => {
    try {
      const cached = localStorage.getItem("branch_access_types");
      return cached ? JSON.parse(cached) : ["Business Loan", "GP Loan", "JLG", "Daily Loan"];
    } catch {
      return ["Business Loan", "GP Loan", "JLG", "Daily Loan"];
    }
  });
  const [pendingSelectedMember, setPendingSelectedMember] = useState();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 992);

  const toggleSidebar = () => {
    setOpenSidebarToggle(prev => !prev);
  };

  useEffect(() => {
    localStorage.setItem("adminUser", JSON.stringify(adminUser));
  }, [adminUser]);

  useEffect(() => {
    const fetchBranchAccess = async () => {
      const userBranchId = adminUser?.user?.branchId;
      if (!userBranchId) {
        setAccessTypes(["Business Loan", "GP Loan", "JLG", "Daily Loan"]);
        return;
      }
      try {
        const response = await fetch(`${BASE_URL}/api/getall/branches`);
        if (response.ok) {
          const branches = await response.json();
          const userBranch = branches.find(
            (branch) => String(branch.id) === String(userBranchId)
          );
          if (userBranch && userBranch.accessType) {
            const accessTypeArray = [
              ...new Set(
                userBranch.accessType
                  .split(",")
                  .map((type) => type.trim())
                  .filter((type) => type && type !== "")
              ),
            ];
            setAccessTypes(accessTypeArray);
            localStorage.setItem("branch_access_types", JSON.stringify(accessTypeArray));
          } else {
            setAccessTypes(["Business Loan", "GP Loan", "JLG", "Daily Loan"]);
          }
        }
      } catch (error) {
        console.error("Error fetching branch access in AdminAuthProvider:", error);
      }
    };

    if (adminUser) {
      fetchBranchAccess();
    }
  }, [adminUser]);

  const adminLogin = (userData) => {
    setAdminUser(userData);
  };

  const adminLogout = () => {
    setAdminUser(null);
    localStorage.removeItem("adminUser");
    localStorage.removeItem("branch_access_types");
    sessionStorage.removeItem("sidebar_dropdowns");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setOpenSidebarToggle(true);
      } else {
        setOpenSidebarToggle(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <AdminAuthContext.Provider value={{
      adminUser,
      adminLogin,
      adminLogout,
      accessTypes,
      setPendingSelectedMember,
      pendingSelectedMember,
      openSidebarToggle,
      setOpenSidebarToggle,
      toggleSidebar
    }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);

  if (!context) {
    throw new Error("useAdminAuth must be used within an AdminAuthProvider");
  }

  return context;
};


export default AdminAuthProvider;
